/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Notes_Incomplete_LabelInputs */



/**
* | output |
* | --- |
* | "Notes Incomplete" |
*
* @param {Style_Guide_Manager_Notes_Incomplete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_notes_incomplete_label = /** @type {((inputs?: Style_Guide_Manager_Notes_Incomplete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Notes_Incomplete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes incompletes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notizen unvollständig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Note incomplete")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примечания неполные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notas incompletas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("备注不完整")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メモが不完全")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स अधूरे हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notas incompletas")
	return /** @type {LocalizedString} */ ("Notes Incomplete")
});